





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { GQL_order_order } from '@/queries/__generated__/order';
import gql from 'graphql-tag';

const INVOICES_SEARCH = gql`
  query invoicesSearchForCreditNoteInvoicePicker(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: InvoiceFilter
  ) {
    invoices(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ) {
      id
      number
      issueDate
      payableAmount
      currencyCode
    }
  }
`;

@Component
export default class CreditNoteInvoicePicker extends Vue {
  @Prop({ required: true }) public order!: GQL_order_order;

  private INVOICES_SEARCH = INVOICES_SEARCH;
  private open = false;

  private selectInvoice(invoice: { number: number | string }) {
    this.order.note = this.$t('Order.creditNoteComment', { number: invoice.number }) as string;

    this.open = false;
  }
}
